import script from "./SfxSelect.vue?vue&type=script&setup=true&lang=ts&generic=T"
export * from "./SfxSelect.vue?vue&type=script&setup=true&lang=ts&generic=T"

const __exports__ = script;

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QField,QSelect});
